import { AppsApi } from 'src/orchd-client';

import { axiosInstance } from 'src/utils/axios';

export const appsApi = AppsApi({}, '/api', axiosInstance);
